import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function Bills() {
  const navigate = useNavigate();
  const [wallet, setWallet] = useState(null);
  const [billType, setBillType] = useState("airtime");

  // Airtime
  const [airtimeNetworks] = useState([
    { id: "mtn", name: "MTN" },
    { id: "glo", name: "Glo" },
    { id: "airtel", name: "Airtel" },
    { id: "9mobile", name: "9mobile" }
  ]);
  const [selectedAirtimeNetwork, setSelectedAirtimeNetwork] = useState("");
  const [airtimePhone, setAirtimePhone] = useState("");
  const [airtimeAmount, setAirtimeAmount] = useState("");
  const [airtimeLoading, setAirtimeLoading] = useState(false);
  const [airtimeResult, setAirtimeResult] = useState(null);
  const [airtimeError, setAirtimeError] = useState("");

  // Data
  const [dataNetworks] = useState([
    { id: "mtn", name: "MTN" },
    { id: "glo", name: "Glo" },
    { id: "airtel", name: "Airtel" },
    { id: "9mobile", name: "9mobile" }
  ]);
  const [selectedDataNetwork, setSelectedDataNetwork] = useState("");
  const [dataPlans, setDataPlans] = useState([]);
  const [selectedDataPlan, setSelectedDataPlan] = useState("");
  const [dataPhone, setDataPhone] = useState("");
  const [dataLoading, setDataLoading] = useState(false);
  const [dataResult, setDataResult] = useState(null);
  const [dataError, setDataError] = useState("");

  // Electricity
  const [discos, setDiscos] = useState([]);
  const [selectedDisco, setSelectedDisco] = useState("");
  const [meterNumber, setMeterNumber] = useState("");
  const [meterType, setMeterType] = useState("prepaid");
  const [electricityAmount, setElectricityAmount] = useState("");
  const [electricityPhone, setElectricityPhone] = useState("");
  const [electricityLoading, setElectricityLoading] = useState(false);
  const [electricityResult, setElectricityResult] = useState(null);
  const [electricityError, setElectricityError] = useState("");

  // Cable TV
  const [cableProviders] = useState([
    { id: "dstv", name: "DSTV" },
    { id: "gotv", name: "GOtv" },
    { id: "startimes", name: "StarTimes" }
  ]);
  const [selectedCableProvider, setSelectedCableProvider] = useState("");
  const [cablePlans, setCablePlans] = useState([]);
  const [selectedCablePlan, setSelectedCablePlan] = useState("");
  const [smartCardNumber, setSmartCardNumber] = useState("");
  const [cableCustomerName, setCableCustomerName] = useState("");
  const [cableLoading, setCableLoading] = useState(false);
  const [cableResult, setCableResult] = useState(null);
  const [cableError, setCableError] = useState("");
  const [validatingCard, setValidatingCard] = useState(false);

  // Betting
  const [bettingProviders] = useState([
    { id: "bet9ja", name: "Bet9ja" },
    { id: "betking", name: "BetKing" },
    { id: "sportybet", name: "SportyBet" },
    { id: "1xbet", name: "1xBet" },
    { id: "betway", name: "Betway" }
  ]);
  const [selectedBettingProvider, setSelectedBettingProvider] = useState("");
  const [bettingCustomerId, setBettingCustomerId] = useState("");
  const [bettingAmount, setBettingAmount] = useState("");
  const [bettingCustomerName, setBettingCustomerName] = useState("");
  const [bettingLoading, setBettingLoading] = useState(false);
  const [bettingResult, setBettingResult] = useState(null);
  const [bettingError, setBettingError] = useState("");
  const [validatingBetting, setValidatingBetting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    loadWallet();
  }, [navigate]);

  const loadWallet = async () => {
    try {
      const res = await api.get("/Wallet/my-wallet");
      setWallet(res.data);
    } catch (err) {
      console.error("Failed to load wallet:", err);
    }
  };

  // ============ AIRTIME ============
  const handleAirtimePayment = async (e) => {
    e.preventDefault();
    setAirtimeError("");
    setAirtimeResult(null);
    setAirtimeLoading(true);

    try {
      const res = await api.post("/vtu/airtime", {
        network: selectedAirtimeNetwork,
        phone: airtimePhone,
        amount: parseFloat(airtimeAmount)
      });

      if (res.data?.success) {
        setAirtimeResult(res.data.data);
        loadWallet();
      } else {
        setAirtimeError(res.data?.message || "Purchase failed");
      }
    } catch (err) {
      setAirtimeError(err.response?.data?.message || "Purchase failed. Please try again.");
    } finally {
      setAirtimeLoading(false);
    }
  };

  const resetAirtimeForm = () => {
    setSelectedAirtimeNetwork("");
    setAirtimePhone("");
    setAirtimeAmount("");
    setAirtimeResult(null);
    setAirtimeError("");
  };

  // ============ DATA ============
  const loadDataPlans = async (network) => {
    try {
      const res = await api.get(`/vtu/data/${network}/plans`);
      if (res.data?.success && res.data?.data) {
        setDataPlans(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load data plans:", err);
      setDataPlans([]);
    }
  };

  const handleDataPayment = async (e) => {
    e.preventDefault();
    setDataError("");
    setDataResult(null);
    setDataLoading(true);

    const selectedPlan = dataPlans.find(p => p.variationId === selectedDataPlan);

    try {
      const res = await api.post("/vtu/data", {
        network: selectedDataNetwork,
        phone: dataPhone,
        planId: selectedDataPlan,
        amount: selectedPlan?.price || 0
      });

      if (res.data?.success) {
        setDataResult(res.data.data);
        loadWallet();
      } else {
        setDataError(res.data?.message || "Purchase failed");
      }
    } catch (err) {
      setDataError(err.response?.data?.message || "Purchase failed. Please try again.");
    } finally {
      setDataLoading(false);
    }
  };

  const resetDataForm = () => {
    setSelectedDataNetwork("");
    setSelectedDataPlan("");
    setDataPhone("");
    setDataPlans([]);
    setDataResult(null);
    setDataError("");
  };

  // ============ ELECTRICITY ============
  const loadDiscos = async () => {
    try {
      const res = await api.get("/vtu/electricity/discos");
      if (res.data?.success && res.data?.data) {
        setDiscos(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load discos:", err);
    }
  };

  const handleElectricityPayment = async (e) => {
    e.preventDefault();
    setElectricityError("");
    setElectricityResult(null);
    setElectricityLoading(true);

    try {
      const res = await api.post("/vtu/electricity", {
        discoId: selectedDisco,
        meterNumber: meterNumber,
        meterType: meterType,
        amount: parseFloat(electricityAmount),
        phone: electricityPhone
      });

      if (res.data?.success) {
        setElectricityResult(res.data.data);
        loadWallet();
      } else {
        setElectricityError(res.data?.message || "Payment failed");
      }
    } catch (err) {
      setElectricityError(err.response?.data?.message || "Payment failed. Please try again.");
    } finally {
      setElectricityLoading(false);
    }
  };

  const downloadReceipt = async (transactionId) => {
    try {
      const response = await api.get(`/vtu/electricity/receipt/${transactionId}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `electricity-receipt-${transactionId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Failed to download receipt");
    }
  };

  const resetElectricityForm = () => {
    setSelectedDisco("");
    setMeterNumber("");
    setMeterType("prepaid");
    setElectricityAmount("");
    setElectricityPhone("");
    setElectricityResult(null);
    setElectricityError("");
  };

  // ============ CABLE TV ============
  const loadCablePlans = async (provider) => {
    try {
      const res = await api.get(`/vtu/cabletv/${provider}/plans`);
      if (res.data?.success && res.data?.data) {
        setCablePlans(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load cable plans:", err);
      setCablePlans([]);
    }
  };

  const validateSmartCard = async () => {
    if (!selectedCableProvider || !smartCardNumber) return;
    setValidatingCard(true);
    setCableCustomerName("");
    try {
      const res = await api.post("/vtu/cabletv/validate", {
        provider: selectedCableProvider,
        smartCardNumber: smartCardNumber
      });
      if (res.data?.success && res.data?.data?.customerName) {
        setCableCustomerName(res.data.data.customerName);
      }
    } catch (err) {
      console.error("Validation failed:", err);
    } finally {
      setValidatingCard(false);
    }
  };

  const handleCablePayment = async (e) => {
    e.preventDefault();
    setCableError("");
    setCableResult(null);
    setCableLoading(true);

    const selectedPlan = cablePlans.find(p => p.variationId === selectedCablePlan);

    try {
      const res = await api.post("/vtu/cabletv", {
        provider: selectedCableProvider,
        smartCardNumber: smartCardNumber,
        variationId: selectedCablePlan,
        amount: selectedPlan?.price || 0
      });

      if (res.data?.success) {
        setCableResult(res.data.data);
        loadWallet();
      } else {
        setCableError(res.data?.message || "Payment failed");
      }
    } catch (err) {
      setCableError(err.response?.data?.message || "Payment failed. Please try again.");
    } finally {
      setCableLoading(false);
    }
  };

  const resetCableForm = () => {
    setSelectedCableProvider("");
    setSelectedCablePlan("");
    setSmartCardNumber("");
    setCableCustomerName("");
    setCablePlans([]);
    setCableResult(null);
    setCableError("");
  };

  // ============ BETTING ============
  const validateBettingAccount = async () => {
    if (!selectedBettingProvider || !bettingCustomerId) return;
    setValidatingBetting(true);
    setBettingCustomerName("");
    try {
      const res = await api.post("/vtu/betting/validate", {
        provider: selectedBettingProvider,
        customerId: bettingCustomerId
      });
      if (res.data?.success && res.data?.data?.customerName) {
        setBettingCustomerName(res.data.data.customerName);
      }
    } catch (err) {
      console.error("Validation failed:", err);
    } finally {
      setValidatingBetting(false);
    }
  };

  const handleBettingPayment = async (e) => {
    e.preventDefault();
    setBettingError("");
    setBettingResult(null);
    setBettingLoading(true);

    try {
      const res = await api.post("/vtu/betting", {
        provider: selectedBettingProvider,
        customerId: bettingCustomerId,
        amount: parseFloat(bettingAmount)
      });

      if (res.data?.success) {
        setBettingResult(res.data.data);
        loadWallet();
      } else {
        setBettingError(res.data?.message || "Payment failed");
      }
    } catch (err) {
      setBettingError(err.response?.data?.message || "Payment failed. Please try again.");
    } finally {
      setBettingLoading(false);
    }
  };

  const resetBettingForm = () => {
    setSelectedBettingProvider("");
    setBettingCustomerId("");
    setBettingAmount("");
    setBettingCustomerName("");
    setBettingResult(null);
    setBettingError("");
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <button onClick={() => navigate("/dashboard")} style={styles.backBtn}>
           Back
        </button>
        <h1 style={styles.title}> Pay Bills</h1>
        <div style={styles.balance}>
          Balance: {wallet?.balance?.toLocaleString() || "0"}
        </div>
      </header>

      {/* Bill Type Tabs */}
      <div style={styles.tabs}>
        <button 
          onClick={() => setBillType("airtime")}
          style={{...styles.tab, ...(billType === "airtime" ? styles.tabActive : {})}}
        >
           Airtime
        </button>
        <button 
          onClick={() => setBillType("data")}
          style={{...styles.tab, ...(billType === "data" ? styles.tabActive : {})}}
        >
           Data
        </button>
        <button 
          onClick={() => { setBillType("electricity"); loadDiscos(); }}
          style={{...styles.tab, ...(billType === "electricity" ? styles.tabActive : {})}}
        >
           Electricity
        </button>
        <button 
          onClick={() => setBillType("cabletv")}
          style={{...styles.tab, ...(billType === "cabletv" ? styles.tabActive : {})}}
        >
           Cable TV
        </button>
        <button 
          onClick={() => setBillType("betting")}
          style={{...styles.tab, ...(billType === "betting" ? styles.tabActive : {})}}
        >
           Betting
        </button>
      </div>

      {/* Airtime Form */}
      {billType === "airtime" && !airtimeResult && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Buy Airtime</h3>
          {airtimeError && <div style={styles.error}>{airtimeError}</div>}
          
          <form onSubmit={handleAirtimePayment}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Network</label>
              <select 
                style={styles.input}
                value={selectedAirtimeNetwork}
                onChange={(e) => setSelectedAirtimeNetwork(e.target.value)}
                required
              >
                <option value="">Select Network</option>
                {airtimeNetworks.map(n => (
                  <option key={n.id} value={n.id}>{n.name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Phone Number</label>
              <input 
                type="tel"
                style={styles.input}
                value={airtimePhone}
                onChange={(e) => setAirtimePhone(e.target.value)}
                placeholder="08012345678"
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Amount ()</label>
              <input 
                type="number"
                style={styles.input}
                value={airtimeAmount}
                onChange={(e) => setAirtimeAmount(e.target.value)}
                placeholder="Enter amount"
                min="50"
                required
              />
            </div>

            <button 
              type="submit" 
              style={styles.submitBtn}
              disabled={airtimeLoading}
            >
              {airtimeLoading ? "Processing..." : "Buy Airtime"}
            </button>
          </form>
        </div>
      )}

      {/* Airtime Success */}
      {billType === "airtime" && airtimeResult && (
        <div style={styles.successCard}>
          <div style={styles.successIcon}></div>
          <h3 style={styles.successTitle}>Airtime Purchased!</h3>
          
          <div style={styles.details}>
            <div style={styles.detailRow}>
              <span>Network:</span>
              <strong>{airtimeResult.network?.toUpperCase()}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Phone:</span>
              <strong>{airtimeResult.phone}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Amount:</span>
              <strong>{airtimeResult.amount?.toLocaleString()}</strong>
            </div>
          </div>

          <button onClick={resetAirtimeForm} style={styles.newBtn}>
            Buy More Airtime
          </button>
        </div>
      )}

      {/* Data Form */}
      {billType === "data" && !dataResult && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Buy Data</h3>
          {dataError && <div style={styles.error}>{dataError}</div>}
          
          <form onSubmit={handleDataPayment}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Network</label>
              <select 
                style={styles.input}
                value={selectedDataNetwork}
                onChange={(e) => {
                  setSelectedDataNetwork(e.target.value);
                  setSelectedDataPlan("");
                  if (e.target.value) loadDataPlans(e.target.value);
                }}
                required
              >
                <option value="">Select Network</option>
                {dataNetworks.map(n => (
                  <option key={n.id} value={n.id}>{n.name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Data Plan</label>
              <select 
                style={styles.input}
                value={selectedDataPlan}
                onChange={(e) => setSelectedDataPlan(e.target.value)}
                required
                disabled={!selectedDataNetwork}
              >
                <option value="">Select Plan</option>
                {dataPlans.map(plan => (
                  <option key={plan.variationId} value={plan.variationId}>
                    {plan.name} - {plan.price?.toLocaleString()}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Phone Number</label>
              <input 
                type="tel"
                style={styles.input}
                value={dataPhone}
                onChange={(e) => setDataPhone(e.target.value)}
                placeholder="08012345678"
                required
              />
            </div>

            <button 
              type="submit" 
              style={styles.submitBtn}
              disabled={dataLoading}
            >
              {dataLoading ? "Processing..." : "Buy Data"}
            </button>
          </form>
        </div>
      )}

      {/* Data Success */}
      {billType === "data" && dataResult && (
        <div style={styles.successCard}>
          <div style={styles.successIcon}></div>
          <h3 style={styles.successTitle}>Data Purchased!</h3>
          
          <div style={styles.details}>
            <div style={styles.detailRow}>
              <span>Network:</span>
              <strong>{dataResult.network?.toUpperCase()}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Phone:</span>
              <strong>{dataResult.phone}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Plan:</span>
              <strong>{dataResult.planName}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Amount:</span>
              <strong>{dataResult.amount?.toLocaleString()}</strong>
            </div>
          </div>

          <button onClick={resetDataForm} style={styles.newBtn}>
            Buy More Data
          </button>
        </div>
      )}

      {/* Electricity Form */}
      {billType === "electricity" && !electricityResult && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Buy Electricity Token</h3>
          {electricityError && <div style={styles.error}>{electricityError}</div>}
          
          <form onSubmit={handleElectricityPayment}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Distribution Company</label>
              <select 
                style={styles.input}
                value={selectedDisco}
                onChange={(e) => setSelectedDisco(e.target.value)}
                required
              >
                <option value="">Select DisCo</option>
                {discos.map(disco => (
                  <option key={disco.id} value={disco.id}>{disco.name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Meter Type</label>
              <div style={styles.radioGroup}>
                <label style={styles.radioLabel}>
                  <input 
                    type="radio" 
                    name="meterType" 
                    value="prepaid"
                    checked={meterType === "prepaid"}
                    onChange={(e) => setMeterType(e.target.value)}
                  />
                  Prepaid
                </label>
                <label style={styles.radioLabel}>
                  <input 
                    type="radio" 
                    name="meterType" 
                    value="postpaid"
                    checked={meterType === "postpaid"}
                    onChange={(e) => setMeterType(e.target.value)}
                  />
                  Postpaid
                </label>
              </div>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Meter Number</label>
              <input 
                type="text"
                style={styles.input}
                value={meterNumber}
                onChange={(e) => setMeterNumber(e.target.value)}
                placeholder="Enter meter number"
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Amount ()</label>
              <input 
                type="number"
                style={styles.input}
                value={electricityAmount}
                onChange={(e) => setElectricityAmount(e.target.value)}
                placeholder="Min 1,000"
                min="1000"
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Phone Number (for token SMS)</label>
              <input 
                type="tel"
                style={styles.input}
                value={electricityPhone}
                onChange={(e) => setElectricityPhone(e.target.value)}
                placeholder="08012345678"
                required
              />
            </div>

            <button 
              type="submit" 
              style={styles.submitBtn}
              disabled={electricityLoading}
            >
              {electricityLoading ? "Processing..." : "Buy Token"}
            </button>
          </form>
        </div>
      )}

      {/* Electricity Success */}
      {billType === "electricity" && electricityResult && (
        <div style={styles.successCard}>
          <div style={styles.successIcon}></div>
          <h3 style={styles.successTitle}>Payment Successful!</h3>
          
          <div style={styles.tokenBox}>
            <span style={styles.tokenLabel}>Your Electricity Token</span>
            <span style={styles.tokenValue}>{electricityResult.token || "N/A"}</span>
          </div>

          <div style={styles.details}>
            <div style={styles.detailRow}>
              <span>Customer Name:</span>
              <strong>{electricityResult.customerName || "N/A"}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Address:</span>
              <strong>{electricityResult.customerAddress || "N/A"}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Meter Number:</span>
              <strong>{electricityResult.meterNumber}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Amount:</span>
              <strong>{electricityResult.amount?.toLocaleString()}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Units:</span>
              <strong>{electricityResult.units || "N/A"}</strong>
            </div>
          </div>

          <div style={styles.actions}>
            <button 
              onClick={() => downloadReceipt(electricityResult.transactionId)}
              style={styles.downloadBtn}
            >
               Download Receipt
            </button>
            <button 
              onClick={resetElectricityForm}
              style={styles.newBtn}
            >
              New Payment
            </button>
          </div>
        </div>
      )}

      {/* Cable TV Form */}
      {billType === "cabletv" && !cableResult && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Cable TV Subscription</h3>
          {cableError && <div style={styles.error}>{cableError}</div>}
          
          <form onSubmit={handleCablePayment}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Provider</label>
              <select 
                style={styles.input}
                value={selectedCableProvider}
                onChange={(e) => {
                  setSelectedCableProvider(e.target.value);
                  setSelectedCablePlan("");
                  setCableCustomerName("");
                  if (e.target.value) loadCablePlans(e.target.value);
                }}
                required
              >
                <option value="">Select Provider</option>
                {cableProviders.map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Smart Card / IUC Number</label>
              <input 
                type="text"
                style={styles.input}
                value={smartCardNumber}
                onChange={(e) => setSmartCardNumber(e.target.value)}
                onBlur={validateSmartCard}
                placeholder="Enter smart card number"
                required
              />
              {validatingCard && <span style={styles.validating}>Validating...</span>}
              {cableCustomerName && (
                <div style={styles.customerInfo}>
                   {cableCustomerName}
                </div>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Package</label>
              <select 
                style={styles.input}
                value={selectedCablePlan}
                onChange={(e) => setSelectedCablePlan(e.target.value)}
                required
                disabled={!selectedCableProvider}
              >
                <option value="">Select Package</option>
                {cablePlans.map(plan => (
                  <option key={plan.variationId} value={plan.variationId}>
                    {plan.name} - {plan.price?.toLocaleString()}
                  </option>
                ))}
              </select>
            </div>

            <button 
              type="submit" 
              style={styles.submitBtn}
              disabled={cableLoading}
            >
              {cableLoading ? "Processing..." : "Subscribe"}
            </button>
          </form>
        </div>
      )}

      {/* Cable TV Success */}
      {billType === "cabletv" && cableResult && (
        <div style={styles.successCard}>
          <div style={styles.successIcon}></div>
          <h3 style={styles.successTitle}>Subscription Successful!</h3>
          
          <div style={styles.details}>
            <div style={styles.detailRow}>
              <span>Customer:</span>
              <strong>{cableResult.customerName || "N/A"}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Smart Card:</span>
              <strong>{cableResult.smartCardNumber}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Package:</span>
              <strong>{cableResult.planName}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Amount:</span>
              <strong>{cableResult.amount?.toLocaleString()}</strong>
            </div>
          </div>

          <button onClick={resetCableForm} style={styles.newBtn}>
            New Subscription
          </button>
        </div>
      )}

      {/* Betting Form */}
      {billType === "betting" && !bettingResult && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Fund Betting Account</h3>
          {bettingError && <div style={styles.error}>{bettingError}</div>}
          
          <form onSubmit={handleBettingPayment}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Betting Platform</label>
              <select 
                style={styles.input}
                value={selectedBettingProvider}
                onChange={(e) => {
                  setSelectedBettingProvider(e.target.value);
                  setBettingCustomerName("");
                }}
                required
              >
                <option value="">Select Platform</option>
                {bettingProviders.map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Customer ID / User ID</label>
              <input 
                type="text"
                style={styles.input}
                value={bettingCustomerId}
                onChange={(e) => setBettingCustomerId(e.target.value)}
                onBlur={validateBettingAccount}
                placeholder="Enter your betting ID"
                required
              />
              {validatingBetting && <span style={styles.validating}>Validating...</span>}
              {bettingCustomerName && (
                <div style={styles.customerInfo}>
                   {bettingCustomerName}
                </div>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Amount ()</label>
              <input 
                type="number"
                style={styles.input}
                value={bettingAmount}
                onChange={(e) => setBettingAmount(e.target.value)}
                placeholder="Enter amount"
                min="100"
                required
              />
            </div>

            <button 
              type="submit" 
              style={styles.submitBtn}
              disabled={bettingLoading}
            >
              {bettingLoading ? "Processing..." : "Fund Account"}
            </button>
          </form>
        </div>
      )}

      {/* Betting Success */}
      {billType === "betting" && bettingResult && (
        <div style={styles.successCard}>
          <div style={styles.successIcon}></div>
          <h3 style={styles.successTitle}>Funding Successful!</h3>
          
          <div style={styles.details}>
            <div style={styles.detailRow}>
              <span>Platform:</span>
              <strong>{bettingResult.provider}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Customer ID:</span>
              <strong>{bettingResult.customerId}</strong>
            </div>
            <div style={styles.detailRow}>
              <span>Amount:</span>
              <strong>{bettingResult.amount?.toLocaleString()}</strong>
            </div>
          </div>

          <button onClick={resetBettingForm} style={styles.newBtn}>
            New Funding
          </button>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#f5f7fa",
    padding: "20px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    flexWrap: "wrap",
    gap: "15px"
  },
  backBtn: {
    padding: "10px 20px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px"
  },
  title: {
    margin: 0,
    fontSize: "24px",
    color: "#1a1a2e"
  },
  balance: {
    padding: "10px 20px",
    backgroundColor: "#1a1a2e",
    color: "#10b981",
    borderRadius: "8px",
    fontWeight: "600"
  },
  tabs: {
    display: "flex",
    gap: "10px",
    marginBottom: "25px",
    flexWrap: "wrap"
  },
  tab: {
    padding: "12px 20px",
    backgroundColor: "#e5e7eb",
    border: "none",
    borderRadius: "25px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s"
  },
  tabActive: {
    backgroundColor: "#3b82f6",
    color: "white"
  },
  card: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "30px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    maxWidth: "500px",
    margin: "0 auto"
  },
  cardTitle: {
    margin: "0 0 25px",
    fontSize: "20px",
    fontWeight: "600",
    color: "#1a1a2e"
  },
  formGroup: {
    marginBottom: "20px"
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151"
  },
  input: {
    width: "100%",
    padding: "12px 15px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "14px",
    boxSizing: "border-box"
  },
  radioGroup: {
    display: "flex",
    gap: "20px"
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    cursor: "pointer"
  },
  submitBtn: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "10px"
  },
  error: {
    backgroundColor: "#fef2f2",
    color: "#dc2626",
    padding: "12px 15px",
    borderRadius: "8px",
    marginBottom: "20px",
    fontSize: "14px"
  },
  validating: {
    fontSize: "12px",
    color: "#6b7280",
    marginTop: "5px",
    display: "block"
  },
  customerInfo: {
    marginTop: "10px",
    padding: "12px 15px",
    backgroundColor: "#d1fae5",
    borderRadius: "8px",
    color: "#065f46",
    fontWeight: "500"
  },
  successCard: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    maxWidth: "500px",
    margin: "0 auto",
    textAlign: "center"
  },
  successIcon: {
    fontSize: "60px",
    marginBottom: "15px"
  },
  successTitle: {
    margin: "0 0 25px",
    fontSize: "22px",
    fontWeight: "600",
    color: "#10b981"
  },
  tokenBox: {
    backgroundColor: "#d1fae5",
    borderRadius: "12px",
    padding: "25px",
    marginBottom: "25px"
  },
  tokenLabel: {
    display: "block",
    fontSize: "13px",
    color: "#065f46",
    marginBottom: "10px"
  },
  tokenValue: {
    display: "block",
    fontSize: "26px",
    fontWeight: "700",
    color: "#1a1a2e",
    letterSpacing: "2px",
    wordBreak: "break-all"
  },
  details: {
    textAlign: "left",
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
    padding: "20px",
    marginBottom: "25px"
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "14px"
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: "15px"
  },
  downloadBtn: {
    padding: "15px",
    backgroundColor: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer"
  },
  newBtn: {
    padding: "15px",
    backgroundColor: "#e5e7eb",
    color: "#374151",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer"
  }
};
